import HttpClient from './HttpClient'

const baseURL = process.env.REACT_APP_BASE_URL || "";

const authKey = process.env.REACT_APP_AUTH_TOKEN || "";


export const Api = new HttpClient(baseURL, authKey)
